// eslint-disable-next-line import/no-cycle
import database from '../model/firebase/firebase';

const current = '1.5.2';
const production = true;

export const checkVersion = async () => {
  try {
    const remote = (await database.collection('API_data').doc('Version').get()).data().version;
    if (current !== remote) {
      document.location.reload(true);
    }
  } catch (e) {
    document.location.reload(true);
  }
};

export default production;
